// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"908":"f597ebb7","6074":"7959fade"}[chunkId] + ".chunk.css";
};